import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  LinearProgress,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Radio,
  RadioGroup
} from '@mui/material';
import React, { FC, memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PopupComponent } from 'src/components/common/PopupComponent';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import DocManagementService from '../documentUpload/service/DocManagementService';
import { hideLoader, showLoader } from 'src/store/Loader';

const OverwriteAndSendNewVersionDialog: FC<any> = ({
  openOverwriteAndNewversion,
  setOpenOverwriteAndNewversion,
  setIsSentToTMF,
  taskId
}: any) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const [isProcessing, setProcessing] = React.useState(false);
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const [checked, setChecked] = useState<boolean>(false);
  const [radVal, setRadVal] = useState<string>('');
  const dispatch = useDispatch();

  const handleCloseDialog = () => {
    setOpenOverwriteAndNewversion(false);
  };

  const handleConfirmClick = async () => {
    dispatch(showLoader());
    const Data = {
      action_name: 'Sent To TMF',
      sent_to_tmf: true,
      is_resolved: false,
      updated_by: userName
    };
    setProcessing(true);
    const response = await docService.sendToTMF(
      documentDetail.data[0].task_Id ? documentDetail.data[0].task_Id : taskId,
      Data,
      selectedStudy,
      selectedCountry,
      selectedSite,
      'Site',
      'ISF',
      'DocumentApproval',
      'SentToTMF',
      radVal === 'overwrite' ? true : false
    );
    if (response?.data) {
      setOpenOverwriteAndNewversion(false);
      setIsSentToTMF(true);
      store.dispatch(setSnackbarMessage('Document sent to TMF successfully.', 'success'));
      setDocumentDetail(dispatch, [{ ...documentDetail.data[0], sent_to_tmf: true }]);
      dispatch(hideLoader());
    } else {
      setOpenOverwriteAndNewversion(false);
      dispatch(hideLoader());
      store.dispatch(setSnackbarMessage('Error in Sending To TMF.', 'error'));
    }
    setProcessing(false);
  };
  const handleRadioValue = (e: any, value: any) => {
    setChecked(true);
    setRadVal(value);
  };
  return (
    <React.Fragment>
      <PopupComponent open={openOverwriteAndNewversion}>
        <DialogTitle>Send to TMF</DialogTitle>
        <DialogContent className="sendToDialog">
          {isProcessing && (
            <Box sx={{ width: '100%' }} mb={2}>
              <LinearProgress />
            </Box>
          )}
          <DialogContentText>
            The current document is already exists in TMF. Please select one of the options below to proceed.
          </DialogContentText>
          <Paper sx={{ width: '100%', maxHeight: 242, bgcolor: 'background.paper', overflowY: 'auto' }}>
            <List dense={true}>
              <ListItem disablePadding>
                <ListItemButton>
                  <ListItemText primary={documentDetail?.data[0]?.isf_document_name} />
                </ListItemButton>
              </ListItem>
            </List>
          </Paper>
          <FormControl>
            <RadioGroup
              aria-labelledby="sent to TMF choice"
              defaultValue=""
              name="radio-buttons-group"
              onChange={handleRadioValue}
            >
              <FormControlLabel value="newVersion" control={<Radio />} label="Send the document as new version" />
              <FormControlLabel value="overwrite" control={<Radio />} label="Overwrite the document" />
            </RadioGroup>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} className="grey-btn" disabled={isProcessing}>
            Cancel
          </Button>
          <Button onClick={handleConfirmClick} disabled={!checked || isProcessing}>
            Send
          </Button>
        </DialogActions>
      </PopupComponent>
    </React.Fragment>
  );
};

export default memo(OverwriteAndSendNewVersionDialog);
